import Container from 'react-bootstrap/Container';
import GamesGetAll from '../services/GamesGetAll';

function Games() {
  return (
    <div>
      <Container>
        <GamesGetAll />
      </Container>
    </div>
  );
}

export default Games;